import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes"

export interface ICalendarPost {
  month: number;
  year: number;
  business_id: any;
}

export interface IReSchedulePost {
  post_id: string;
  date: string;
}

export const createMomentApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.createMoment, payload)
  return response
}

export const getCalendarPostApi = async (payload: ICalendarPost) => {
  const response = await AxiosInstance.post(apiRoutes?.getCalendarPost, payload)
  return response
}

export const getPostDetailsApi = async (payload: { post_id: string }) => {
  const response = await AxiosInstance.post(apiRoutes?.getPost, payload)
  return response
}

export const ReSchedulePostApi = async (payload: IReSchedulePost) => {
  const response = await AxiosInstance.post(apiRoutes?.reSchedulePost, payload)
  return response
}

export const editPostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editPost, payload)
  return response
}

export const editGBPPostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editGBPPost, payload)
  return response
}

export const editFacebookPostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editFacebookPost, payload)
  return response
}

export const editInstagramPostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editInstagramPost, payload)
  return response
}

export const editWebsitePostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editWebsitePost, payload)
  return response
}
export const editYoutubePostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editYoutubePost, payload)
  return response
}

export const editTiktokPostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editTiktokPost, payload)
  return response
}

export const updatePostStatusApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.updatePostStatus, payload)
  return response
}

export const retryPostApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.retryPost, payload)
  return response
}
export const bulkRetryPostApi = async (payload: { post_ids: string[] }) => {
  const response = await AxiosInstance.post(apiRoutes?.bulkRetryPost, payload)
  return response
}
export const deletePostApi = async (payload: { post_ids: string[] }) => {
  const response = await AxiosInstance.post(apiRoutes?.deletePost, payload)
  return response
}

export const regenerateYoutubeVideoApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.regenerateYoutubeVideo, payload)
  return response
}

export const regenerateYoutubeAudioApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.regenerateYoutubeAudio, payload)
  return response
}

export const regenerateTiktokVideoApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.regenerateTiktokVideo, payload)
  return response
}

export const regenerateTiktokAudioApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.regenerateTiktokAudio, payload)
  return response
}